const base = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function IdCardIcon(props) {
  return (
    <svg {...base} {...props}>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <circle cx="8" cy="11" r="2" />
      <path d="M6 16c0-1.5 1-2.5 2-2.5s2 1 2 2.5" />
      <line x1="13" y1="9" x2="19" y2="9" />
      <line x1="13" y1="13" x2="19" y2="13" />
    </svg>
  );
}

export function SearchIcon(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

export function CheckBadgeIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 2l2.4 1.7 2.9-.3 1 2.8 2.6 1.4-.6 2.9 1.4 2.5-2 2.2.4 2.9-2.8.9-1.6 2.5H9.3l-1.6-2.5-2.8-.9.4-2.9-2-2.2 1.4-2.5-.6-2.9 2.6-1.4 1-2.8 2.9.3z" />
      <path d="M8.5 12.5l2.3 2.3 4.7-4.8" />
    </svg>
  );
}

export function AlertIcon(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="8" x2="12" y2="13" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}

export function InfoIcon(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="11" x2="12" y2="16" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
}

export function CheckIcon(props) {
  return (
    <svg {...base} strokeWidth={2.6} {...props}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

export function XCircleIcon(props) {
  return (
    <svg {...base} strokeWidth={1.6} {...props}>
      <circle cx="12" cy="12" r="9.2" />
      <line x1="8.5" y1="8.5" x2="15.5" y2="15.5" />
      <line x1="15.5" y1="8.5" x2="8.5" y2="15.5" />
    </svg>
  );
}

export function SpinnerIcon(props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="spin" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" opacity="0.25" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}
